import * as React from 'react';
function CodeIconComponent(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m5.525 13.84 4.004-12 .948.316-4.003 12-.949-.316Zm-.878-1.82-3.43-3.43a.839.839 0 0 1 0-1.18l3.43-3.43.706.707L2.04 8l3.313 3.313-.706.707Zm6.707 0-.707-.707L13.96 8l-3.313-3.313.707-.707 3.43 3.43a.839.839 0 0 1 0 1.18l-3.43 3.43Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default CodeIconComponent;
